"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A handler for converting GraphQL nodes to operations.
 */

var NodeHandlerAdapter =
/*#__PURE__*/
function () {
  function NodeHandlerAdapter(targetKind, util, settings) {
    _classCallCheck(this, NodeHandlerAdapter);

    this.targetKind = targetKind;
    this.util = util;
    this.settings = settings;
  }
  /* ----- Node quad context ----- */

  /**
   * Get the quad context of a selection set node that should be used for the whole definition node.
   *
   * This is a pre-processing step of selection sets.
   * Its only purpose is to determine the subject within a selection set,
   * because this subject is needed to link with its parent.
   * In a later phase, the selection set will be processed using the discovered subject,
   * and the field identifying the subject will be ignored.
   *
   * @param {SelectionSetNode} selectionSet A selection set node.
   * @param {string} fieldLabel A field label.
   * @param {IConvertContext} convertContext A convert context.
   * @return {INodeQuadContext} The subject, graph and auxiliary patterns.
   */


  _createClass(NodeHandlerAdapter, [{
    key: "getNodeQuadContextSelectionSet",
    value: function getNodeQuadContextSelectionSet(selectionSet, fieldLabel, convertContext) {
      var nodeQuadContext = {};

      if (selectionSet) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = selectionSet.selections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var selectionNode = _step.value;

            if (selectionNode.kind === 'Field') {
              var fieldNode = selectionNode;
              this.handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, 'id', 'subject');
              this.handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, 'graph', 'graph');
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return nodeQuadContext;
    }
    /**
     * Handles a single field for determining the node quad context.
     * @param {FieldNode} fieldNode A field node.
     * @param {IConvertContext} convertContext A convert context.
     * @param {INodeQuadContext} nodeQuadContext The node quad context to populate.
     * @param {string} fieldName The field name to check for.
     * @param {'subject' | 'graph'} nodeQuadContextKey The key to fill into the node quad context.
     */

  }, {
    key: "handleNodeQuadContextField",
    value: function handleNodeQuadContextField(fieldNode, convertContext, nodeQuadContext, fieldName, nodeQuadContextKey) {
      if (!nodeQuadContext[nodeQuadContextKey] && fieldNode.name.value === fieldName) {
        // Get (or set) the nodeQuadContextKey for fieldName fields
        if (!nodeQuadContext[nodeQuadContextKey]) {
          var argument = this.util.getArgument(fieldNode.arguments, '_');

          if (argument) {
            var valueOutput = this.util.handleNodeValue(argument.value, fieldNode.name.value, convertContext);

            if (valueOutput.terms.length !== 1) {
              throw new Error("Only single values can be set as ".concat(fieldName, ", but got ").concat(valueOutput.terms.length, " at ").concat(fieldNode.name.value));
            }

            nodeQuadContext[nodeQuadContextKey] = valueOutput.terms[0];

            if (valueOutput.auxiliaryPatterns) {
              if (!nodeQuadContext.auxiliaryPatterns) {
                nodeQuadContext.auxiliaryPatterns = [];
              }

              nodeQuadContext.auxiliaryPatterns.concat(valueOutput.auxiliaryPatterns);
            }
          }
        }

        if (!nodeQuadContext[nodeQuadContextKey]) {
          var term = this.util.nameToVariable(this.util.getFieldLabel(fieldNode), convertContext);
          convertContext.terminalVariables.push(term);
          nodeQuadContext[nodeQuadContextKey] = term;
        }
      }
    }
    /* ----- Directives ----- */

    /**
     * Get an operation override defined by one of the directives.
     *
     * This should be called before a sub-operation is handled.
     *
     * @param {ReadonlyArray<DirectiveNode>} directives An option directives array.
     * @param {string} fieldLabel The current field label.
     * @param {IConvertContext} convertContext A convert context.
     * @return {IDirectiveNodeHandlerOutput[]} The directive node handler outputs, or null if it should be ignored.
     */

  }, {
    key: "getDirectiveOutputs",
    value: function getDirectiveOutputs(directives, fieldLabel, convertContext) {
      var outputs = [];

      if (directives) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = directives[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var directive = _step2.value;
            var output = this.util.handleDirectiveNode({
              directive: directive,
              fieldLabel: fieldLabel
            }, convertContext);

            if (output) {
              if (output.ignore) {
                return null;
              }

              outputs.push(output);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return outputs;
    }
    /**
     * Handle the directive outputs with respect to an operation.
     *
     * This should be called after a sub-operation was handled.
     *
     * @param {IDirectiveNodeHandlerOutput[]} directiveOutputs
     * @param {Operation} operation
     * @return {Operation}
     */

  }, {
    key: "handleDirectiveOutputs",
    value: function handleDirectiveOutputs(directiveOutputs, operation) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = directiveOutputs[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var directiveOutput = _step3.value;

          if (directiveOutput.ignore) {
            return this.util.operationFactory.createBgp([]);
          }

          if (directiveOutput.operationOverrider) {
            operation = directiveOutput.operationOverrider(operation);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return operation;
    }
  }]);

  return NodeHandlerAdapter;
}();

exports.NodeHandlerAdapter = NodeHandlerAdapter;